import { useTranslation } from 'react-i18next'
import { MemberRow } from './MemberRow'
import type { HouseholdMember } from './useHouseholdMembers'

interface Props {
  members: HouseholdMember[]
  currentUserId: string
}

export function MemberList({ members, currentUserId }: Props) {
  const { t } = useTranslation()

  const currentMember = members.find((m) => m.userId === currentUserId)
  const currentUserRole = currentMember?.role ?? 'Member'
  const plannerCount = members.filter((m) => m.role === 'Planner').length
  const isLastPlanner = plannerCount <= 1

  return (
    <section>
      <h2 className="text-xl font-semibold text-ink mb-4">{t('household.members.title')}</h2>
      <div className="bg-surface rounded-xl border border-line overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-line">
              <th className="text-left text-xs font-medium text-muted uppercase tracking-wide px-4 py-3">Name</th>
              <th className="text-left text-xs font-medium text-muted uppercase tracking-wide px-4 py-3">Email</th>
              <th className="text-left text-xs font-medium text-muted uppercase tracking-wide px-4 py-3">{t('household.members.roleLabel')}</th>
              <th className="text-left text-xs font-medium text-muted uppercase tracking-wide px-4 py-3">{t('household.members.joinedLabel')}</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {members.map((member) => (
              <MemberRow
                key={member.id}
                member={member}
                currentUserId={currentUserId}
                currentUserRole={currentUserRole}
                isLastPlanner={isLastPlanner}
              />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
